import requestWrapper from '../shared/lib/requestWrapper';
import constants from '../shared/constants';

async function create(payload) {
    var response = await requestWrapper({
        url:    '/AppointmentDietaryDiagnostic',
        method: 'POST',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function remove(payload) {
    var response = await requestWrapper({
        url:    '/AppointmentDietaryDiagnostic/appointment/' + payload.data.idAppointment + '/dietaryDiagnostic/' + payload.data.idDietaryDiagnostic,
        method: 'DELETE',
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

async function search(payload) {
    var response = await requestWrapper({
        url:    '/AppointmentDietaryDiagnostic/search',
        method: 'POST',
        data: payload.data,
        baseURL: constants.sdn.baseUrl,
        notifications: payload.notifications
    });

    return response;
}

const AppointmentDietaryDiagnosticService = {
    create, remove, search
}

export default AppointmentDietaryDiagnosticService;